// pipe: frontend wave — Work sidebar entry (links to the Work dashboard; the in-family nav
// reaches boards/items/feedback/requests/forms/checklists/directory/org-chart/automations).
// Cloned from records-button.tsx / ops-button.tsx (verbatim shape) — only the route, the
// active-path prefix, the icon, the label key, and the testid differ. NOT admin-gated: these
// are ops screens for Erp staff — the server 403s unauthorized reads and the screens render
// the localized load-error state.
import { useI18n } from '@affine/i18n';
import { DatabaseKanbanViewIcon } from '@blocksuite/icons/rc';
import { useServices } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { WorkbenchService } from '../../modules/workbench';
import { useNavPrefixActive } from './use-nav-prefix-active';

export const WorkButton = () => {
  const t = useI18n();
  const { workbenchService } = useServices({ WorkbenchService });
  const workbench = workbenchService.workbench;
  // REACTIVE active state: any /work/* route keeps the entry lit.
  const active = useNavPrefixActive(workbench, '/work');

  return (
    <MenuLinkItem
      icon={<DatabaseKanbanViewIcon />}
      active={active}
      to={'/work/dashboard'}
    >
      <span data-testid="pipe-work-nav">{t['com.affine.pipe.work.nav']()}</span>
    </MenuLinkItem>
  );
};
